export default __webpack_public_path__ + "static/media/edu_1.af9b69d9.png";